
import { api, userApi } from '@/api/axiosConfig';




export const getUserEvents = () => api.get(`/eventsRegist/myEvents`);
export const register=( username,password,phone,smscode,email) =>
     userApi.post('/sys/user/register', { username: username, password: password, phone: phone, smscode: smscode,email:email }, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
export const getSmsCode = (phone, mode) => userApi.post('/sys/sms', { mobile: phone, smsmode: mode }, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
export const phoneLogin = (phone, code) => userApi.post('/sys/phoneLogin', { mobile: phone, captcha: code }, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
export const login = (username, password) => userApi.post('/sys/mLogin',
    { username: username, password: password }
    , { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
export const logout = () => userApi.post('/sys/logout' );
export const getUserInfo = () => userApi.get(`/sys/user/detail`);
export const updateUserInfo = (userInfo) => userApi.post('/sys/user/appEdit', userInfo, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
export const wxMobileLogin=(code,rurl) =>userApi.get('/wx/auth/mobileLogin',{params:{code:code,rurl:rurl}})
export const changePassword =(pwdInfo) => userApi.post('/sys/user/passwordChange', pwdInfo, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } });
export default {
    register,
    logout,
    wxMobileLogin,
    login,
    phoneLogin,
    getSmsCode,
    updateUserInfo,
    changePassword,
    getUserInfo,
    getUserEvents
}